<template>
  <div class="shell">
    <ShellSidebar
      v-model:open="sidebarOpen"
      v-model:peek="sidebarPeek"
      :loading="loading || navTree === undefined"
      :tree="navTree"
      :error-message="errorMessage"
      @navigate="navigate"
    />
    <div
      class="d-flex flex-column overflow-hidden w-100"
      :style="{'padding-left': sidebarOpen ? 'var(--shell-sidebar-width)' : 0}"
    >
      <ShellHeader
        v-model:open="sidebarOpen"
        v-model:peek="sidebarPeek"
        :loading="loading"
        @navigate="navigate"
      />
      <main
        id="scrolling"
        :class="[
          'flex-grow-1 overflow-x-hidden mh-100 custom-scrollbar',
          {'py-3': isFlush === false},
        ]"
      >
        <slot />
      </main>
    </div>
  </div>
</template>
<script lang="ts" setup>
defineProps<{loading: boolean; errorMessage?: string}>();
const coresStore = useCoresStore();
const navTree = computed(() => coresStore.navTree || []);

const {isMobile} = useBsBreakpoints();
const sidebarOpen = ref(!isMobile.value);
const sidebarPeek = ref(false);

import {applicationShellKey} from '@/components/root/shell/injectionKeys';
provide(applicationShellKey, sidebarOpen);

const route = useRoute();
const isFlush = computed(() => route.meta?.node?.meta?.type === 'cms.IFramePage');

const router = useRouter();
const navigate = (meta: SpherePageMeta<SpherePageType>) => {
  if (meta.type === 'cms.DashboardPage' && meta.slug === 'home') {
    router.push({path: '/home', query: route.query, hash: route.hash});
  } else {
    const prefix = meta.type === 'cms.DashboardPage' ? 'core' : 'page';
    const to = router.resolve({name: `${prefix}-${meta.id}`});
    router.push({...to, query: route.query, hash: route.hash}); // Resolve removes hash/query
  }
  if (isMobile.value) sidebarOpen.value = sidebarPeek.value = false;
};
</script>
<style lang="scss" scoped>
.shell {
  --shell-header-height: 3rem;
  --shell-sidebar-width: 20rem;

  display: flex;
  height: 100%;
  overflow: hidden;
}
</style>
